module.exports = __webpack_public_path__ + "static/media/snow 13d.be2864bf.png";